import axios from 'axios';

import {
  axiosHeader,
  publicAxiosHeader,
  getV1RootUrl
} from 'common/helpers/apiHelper';

export const listOrders = (customerId, queryString) => {
  if (queryString) {
    return axios.get(
      `${getV1RootUrl()}/customer/${customerId}/order?${queryString}`,
      axiosHeader()
    );
  }
  return axios.get(
    `${getV1RootUrl()}/customer/${customerId}/order`,
    axiosHeader()
  );
};

export const getOrder = (customerId, orderId) =>
  axios.get(
    `${getV1RootUrl()}/customer/${customerId}/order/${orderId}`,
    axiosHeader()
  );

export const getOrderByEmailOrderNumber = (email, orderNumber) =>
  axios.get(
    `${getV1RootUrl()}/order/limited?email=${encodeURIComponent(
      email
    )}&orderNumber=${orderNumber}`,
    publicAxiosHeader()
  );
